import React from "react";
import Footer from "../../components/Footer";
import StudentForm from "../../components/forms/Communicate/Student"
import NavBar from "../../components/navbar-components/NavBar";

const Student = () => {
    return (
        <>
        <NavBar/>
        <div className="bg-gray-200 py-5">
            <StudentForm/>
        </div>
        <Footer/>
        </>
    )
}

export default Student